<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <!-- <v-head  ></v-head> -->
      <div class="group_1 flex-col">
        <!-- <img class="icon_1" referrerpolicy="no-referrer" src="../../../assets/images/user/success.png" /> -->
        <div class="text-group_1 flex-col">
          <span v-if="orderDetail.payType == 1" class="text_1">支付成功</span>
          <span v-if="orderDetail.payType == 2" class="text_1">提交成功，等待付款审核</span>
          <span class="text_2">¥&nbsp;{{orderDetail.amount }}</span>
        </div>
        <div class="text-wrapper_1 flex-row justify-between">
          <span class="text_3">订单编号</span>
          <span class="text_4">{{ orderDetail.orderNo }}</span>
        </div>
        <div v-if="orderDetail.payType == 1" class="text-wrapper flex-row justify-between">
          <span class="text_5">支付时间</span>
          <span class="text_6">{{ orderDetail.payTime | deepTime }}</span>
        </div>
        <div v-if="orderDetail.payType == 2" class="text-wrapper flex-row justify-between">
          <span class="text_5">提交时间</span>
          <span class="text_6">{{ orderInfo.createdDate | deepTime }}</span>
        </div>
        <div class="section_1 flex-col justify-between" v-if="type == 2">
          <span class="text_7">转账凭证</span>
          <div class="group_2 flex-col" v-if="orderInfo.offlineVoucher">
            <!-- <img
            :src="orderInfo.photoId"
            /> -->
            <van-image-preview v-model="showImg" :images="images" :show-index="showIndex" :closeable="closeable"
              @close="onClose">
            </van-image-preview>
            <van-image style="max-width:5rem" fit="cotain" height="100%" :src="orderInfo.photoId" @click="showPhoto()">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
        </div>
      </div>
      <div class="group_3 flex-col">
        <span class="text_8">报名信息</span>
        <div class="box_2 flex-row justify-between">
          <span class="text_9">会议名称</span>
          <span class="paragraph_1">
            {{ orderDetail.meetingName }}
          </span>
        </div>
        <div class="box_2 flex-row justify-between">
          <span class="text_10">举办时间</span>
          <span class="text_11">{{ orderDetail.startDate | changeTime }}至{{ orderDetail.endDate | changeTime }}</span>
        </div>
      </div>
      <div class="group_4 flex-col">
        <span class="text_14">费用信息</span>
        <div class="list_1 flex-col">
          <div class="text-wrapper_5 flex-row justify-between">
            <span class="text_15">实付金额</span>
            <span class="text_16" style=" color: rgba(26,26,26,1) ">¥&nbsp;{{ orderDetail.amount }}</span>
          </div>
          <div class="text-wrapper_5 flex-row justify-between">
            <span class="text_15">报名费</span>
            <span class="text_16" style=" color: rgba(26,26,26,1) ">¥&nbsp;{{ orderDetail.totalRegistrationFee }}</span>
          </div>
        </div>
      </div>
      <div class="group_10 flex-col">
        <div class="section_2 flex-row justify-between">
          <button class="button_1 flex-col" @click="gopush()">
            <span class="text_17">去开票</span>
          </button>
          <!-- <button class="button_2 flex-col" @click="onClick_2">
            <span class="text_18">论文投稿</span>
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import vHead from "../../../components/Subhead.vue"
  import { Image, Loading } from "vant"
  import {
    getPZUrl,
    meetingOrderDetails
  } from "@/api/dictionary"
  export default {
    data() {
      return {
        orderInfo: {},
        // loading:false,
        loopData0: [
          {
            lanhutext0: "报名费",
            lanhutext1: "¥&nbsp;",
            lanhufontColor1: "rgba(26,26,26,1)",
          },
          {
            lanhutext0: "实付金额",
            lanhutext1: "¥&nbsp;",
            lanhufontColor1: "rgba(26,26,26,1)",
          },

        ],
        constants: {},
        images: [],
        showImg: false,
        showIndex: false,
        closeable: true,
        orderDetail: {
          payType: 2,
        },
      }
    },
    components: {
      vHead,
      [Image.name]: Image,
      [Loading.name]: Loading,
    },
    computed: {
      type() {
        return this.$route.query && this.$route.query.type
      },
    },
    methods: {
      gopush() {
        this.$router.push({ name: "invoicePage" ,query: { orderId: this.orderDetail.orderId }})
      },
      showPhoto() {
        this.showImg = true
      },
      onClose() {
        // this.images = []
      },
    },
    mounted() {
      let orderNo = this.$route.query && this.$route.query.orderNo
      meetingOrderDetails({ orderNo: orderNo }).then((res) => {
        this.orderDetail = res.result
        document.title = res.result.meetingName
      })
      let orderInfo = sessionStorage.getItem("meetingOrderInfo")
      if (orderInfo) {
        this.orderInfo = JSON.parse(orderInfo)
        if (this.orderInfo.offlineVoucher) {
          getPZUrl({ id: this.orderInfo.offlineVoucher }).then((res) => {
            console.log("photo1", this.orderInfo.offlineVoucher)

            this.orderInfo.photoId = res.result
            this.images.push(res.result.toString())
          })
        }
      }

      this.loopData0[0].lanhutext1 =
        this.loopData0[0].lanhutext1 + this.orderInfo.amount
      this.loopData0[1].lanhutext1 =
        this.loopData0[1].lanhutext1 + this.orderInfo.registerAmount
    },
  }
</script>
<style scoped>
  .justify-between {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
  }

  .flex-row {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
  }

  .page {
    background-color: rgba(245, 245, 247, 1);
    position: relative;
    overflow: hidden;
  }

  .box_1 {
    padding-top: 30px;
    display: flex;
    flex-direction: column;
  }

  .group_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    width: 360px;
    align-self: center;
    padding: 10px 0 48px 0;
    display: flex;
    flex-direction: column;
  }

  .icon_1 {
    width: 20px;
    height: 20px;
    align-self: center;
  }

  .text-group_1 {
    width: 176px;
    align-self: center;
    margin-top: 16px;
  }

  .section_2 {
    margin-bottom: 48px;
  }

  .text_1 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 22px;
    display: inline-block;
    width: 100%;
    text-align: center;
  }

  .text_2 {
    display: block;
    width: auto;
    overflow-wrap: break-word;
    color: #000;
    font-size: 20px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;
    line-height: 28px;
    margin: 10px 39px 0 40px;
  }

  .text-wrapper_1 {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 18px 14px 16px;
  }

  .text_3 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .text-wrapper {
    background-color: rgba(255, 255, 255, 1);
    padding: 14px 21px 14px 16px;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-top: 1px;
  }

  .section_1 {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    padding: 14px 308px 14px 16px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_2 {
    position: absolute;
    right: 16px;
    top: 0;
    height: 82px;
  }

  .group_3 {
    /* margin-top: 20px; */
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    width: 360px;
    align-self: center;
    margin: 20px 13px 0 13px;
    padding: 16px 0 16px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    padding-bottom: -9px;
    margin: 0 308px 0 16px;
  }

  .box_2 {
    background-color: rgba(255, 255, 255, 1);
    position: relative;
    padding: 28px 16px 0 16px;
  }

  .text_9 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .paragraph_1 {
    /* height: 45px; */
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    line-height: 22px;
  }

  .text-wrapper_3 {
    background-color: rgba(255, 255, 255, 1);
    position: absolute;
    left: 0;
    top: 69px;
    width: 350px;
    height: 50px;
    padding: 14px 21px 14px 16px;
  }

  .text_10 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text-wrapper_4 {
    width: 356px;
    align-self: center;
    margin-top: 55px;
  }

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 4px;
    width: 360px;
    align-self: center;
    margin-top: -1px;
    margin: 20px 13px 0 13px;
    padding: 16px 0 0;
  }

  .text_14 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
    margin: 0 308px 0 16px;
  }

  .list_1 {
    /* height: 200px; */
    margin-top: 10px;
  }

  .text-wrapper_5 {
    background-color: rgba(255, 255, 255, 1);
    width: 320px;
    padding: 14px 18px 14px 16px;
  }

  .text_15 {
    width: 80px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 16px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .text_16 {
    /* width: 76px; */
    overflow-wrap: break-word;
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 22px;
  }

  .group_10 {
    padding: 30px 0 0 0;
    margin: 0 auto;
  }

  .button_1 {
    border-radius: 28px;
    border: 1px solid #1989fa;
    padding: 7px 27px 6px 28px;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: #1989fa;
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }

  .button_2 {
    background-color: rgba(246, 109, 17, 1);
    border-radius: 28px;
    border: 1px solid rgba(246, 109, 17, 1);
    padding: 7px 41px 6px 42px;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
  }
</style>